import type { AiEstimateSource, AiRunEstimate } from '@mtgcraft/shared';

import { formatElapsed } from '../hooks/useElapsedTimer';

/** Dollar amounts here are fractions of a cent, so keep enough digits to compare runs. */
export function formatUsd(value: number | null | undefined, digits = 4): string {
  if (value === null || value === undefined) return '—';
  if (value > 0 && value < 10 ** -digits) return `<$${(10 ** -digits).toFixed(digits)}`;
  return `$${value.toFixed(digits)}`;
}

export function formatDuration(ms: number | null | undefined): string {
  return ms === null || ms === undefined || ms <= 0 ? '—' : formatElapsed(ms);
}

const SOURCE_LABEL: Record<AiEstimateSource, string> = {
  stats: 'from recent runs',
  'stats-all-versions': 'from runs across prompt versions',
  profile: 'from the feature profile',
};

export function describeEstimateSource(estimate: Pick<AiRunEstimate, 'source' | 'sample_size'>): string {
  return estimate.source === 'profile' ? SOURCE_LABEL.profile : `${SOURCE_LABEL[estimate.source]} (n=${estimate.sample_size})`;
}
